export const normalizeBaseUrl = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) {
    return 'http://localhost:4000'
  }

  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed
}

export const parseResponsePayload = async (response: Response): Promise<unknown> => {
  const text = await response.text()
  if (!text) {
    return undefined
  }

  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export const extractPayloadMessage = (payload: unknown, fallback: string): string => {
  if (!payload) {
    return fallback
  }

  if (typeof payload === 'string') {
    return payload
  }

  if (typeof payload === 'object') {
    const message = (payload as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) {
      return message
    }

    if (Array.isArray(message)) {
      return message.map((item) => String(item)).join('; ')
    }
  }

  return fallback
}

export const extractErrorMessage = extractPayloadMessage
